import { IDropdownOption } from "@/common/entity/Entity";
import { setLanguageAndFormatTime } from "@/common/languages/i18next";
import { changeLanguageDate } from "@/common/languages/moment";
import Canvas from "@/components/ui/Canvas";
import { ICanvasProps } from "@/components/ui/Canvas/Models";
import Dropdown from "@/components/ui/Dropdown";
import { RenderIconEarth } from "@/components/ui/Icons/IconsCustom";
import { RootState } from "@/redux";
import { IOrganizationStore } from "@/redux/slices/organizations/OrganizationModel";
import { ISettingStore } from "@/redux/slices/settings/SettingModel";
import { updateLanguage } from "@/redux/slices/settings/SettingSlice";
import { IFetchRequest } from "@/services";
import type {
  OptionOnSelectData,
  SelectionEvents,
} from "@fluentui/react-components";
import { MessageBarTitle, Option } from "@fluentui/react-components";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { IMessageItem } from "../Models";
import { HeaderTitleWrapper } from "../Styles";
import {
  LanguageBaseWrapper,
  LanguageContentBaseWrapper,
  LanguageContentRowBaseWrapper,
} from "./Styles";
export class LanguageSettingsProp {
  addMessage?: (payload: IMessageItem) => void;
}

const listLanguage: IDropdownOption[] = [
  {
    id: "zh",
    label: "中文(中国",
  },
  {
    id: "cs",
    label: "Čeština (Česká Republika)",
  },
  {
    id: "da",
    label: "Dansk",
  },
  {
    id: "nl",
    label: "Nederlands",
  },
  {
    id: "en",
    label: "English (United States)",
  },
  {
    id: "fi",
    label: "Suomi",
  },
  {
    id: "fr",
    label: "Français",
  },
  {
    id: "de",
    label: "Deutsch",
  },
  {
    id: "it",
    label: "Italiano",
  },
  {
    id: "nb",
    label: "Norsk Bokmål",
  },
  {
    id: "pl",
    label: "Polski (Polska)",
  },
  {
    id: "pt",
    label: "Português",
  },
  {
    id: "es",
    label: "Español",
  },
  {
    id: "sv",
    label: "Svenska",
  },
  {
    id: "cy",
    label: "Cymraeg",
  },
];

const LanguageSetting = (props: LanguageSettingsProp) => {
  const { t } = useTranslation();

  const settingStore: ISettingStore = useSelector(
    (state: RootState) => state.settingInfo
  ) as ISettingStore;

  // const settings = useSelector((state: RootState) => state.settings); // Giả sử tên slice của bạn là "settings"

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [language, setLanguage] = useState<string>(settingStore.language || "");
  const [mapOption, setOption] = useState<Record<string, string>>({});

  const dispatch = useDispatch();

  const [initialLanguage, setInitialLanguage] = useState<string>(settingStore.language || "");

  useEffect(() => {
    if (settingStore.language) {
      setInitialLanguage(settingStore.language);
      setLanguage(settingStore.language);
    }
  }, [settingStore.language]);

  useEffect(() => {
    if (listLanguage.length) {
      const mapValue: Record<string, string> = {};
      listLanguage.forEach((item: IDropdownOption) => {
        mapValue[item.id] = item.label;
      });
      setOption(mapValue);
    }
  }, []);

  const changeLanguageLocal = () => {
    setLanguageAndFormatTime(language)
    changeLanguageDate(language);
  }

  const args: ICanvasProps = {
    headerTitle: (
      <HeaderTitleWrapper className="HeaderTitleWrapper">
        <RenderIconEarth theme={settingStore.theme} />
        <span>{t("Language")}</span>
      </HeaderTitleWrapper>
    ),
    isStickHeader: false,
    isOpen: isOpen,
    onOpen: (isOpen: boolean) => {
      setIsOpen(isOpen);
    },
  };
  const orgStore: IOrganizationStore = useSelector(
    (state: RootState) => state.orgInfo
  ) as IOrganizationStore;

  const handleSaveSettings = () => {
    try {
      const OrganizationInfo: IFetchRequest = {
        tenantId: orgStore.orgInfo?.tenantId ?? "",
        orgId: orgStore.orgInfo?.guid ?? "",
      };
      changeLanguageDate(language || null);
      dispatch(
        updateLanguage({
          value: language,
          OrganizationInfo,
        })
      );
      changeLanguageLocal()

      const msg: IMessageItem = {
        id: new Date().getTime().toString(),
        type: "success",
        content: (
          <>
            <MessageBarTitle>{t("Save language successfully")}!</MessageBarTitle>
          </>
        ),
        autoClose: 3000,
      };
      props?.addMessage && props.addMessage(msg);
    } catch (error) {
      console.error("Đã xảy ra lỗi khi lưu cài đặt:", error);
      const errorMsg: IMessageItem = {
        id: new Date().getTime().toString(),
        type: "error",
        content: (
          <>
            <MessageBarTitle>Something error!</MessageBarTitle>
          </>
        ),
        autoClose: 5000,
      };
      props?.addMessage && props.addMessage(errorMsg);
    }
  };

  const onOptionSelect = (
    _event: SelectionEvents,
    data: OptionOnSelectData
  ) => {
    setLanguage(data.optionValue || "");
  };

  const isLanguageChanged = language !== initialLanguage;

  return (
    <LanguageBaseWrapper className="LanguageBaseWrapper">
      <Canvas {...args} theme={settingStore.theme || undefined}>
        <LanguageContentBaseWrapper className="rf-settings-content">
          <LanguageContentRowBaseWrapper>
            <Dropdown
              placeholder={t("Select an language")}
              selectedOptions={[language]}
              value={mapOption[language] || undefined}
              onOptionSelect={onOptionSelect}
            >
              {listLanguage.map((item: IDropdownOption) => (
                <Option key={item.id} value={item.id}>
                  {item.label}
                </Option>
              ))}
            </Dropdown>
            <div className="btn-group">
              <div
                className={`rf-settings-button-apply ${isLanguageChanged ? 'active' : ''}`}
                onClick={() => {
                  isLanguageChanged && handleSaveSettings();
                }}
                title={t("Apply")}
                style={{
                  backgroundColor: isLanguageChanged ? '#0078d4' : '#b9b9b9',
                  color: isLanguageChanged ? 'white' : '#f1f0ef',
                  cursor: isLanguageChanged ? 'pointer' : 'default',
                }}
              >
                {t("Apply")}
              </div>
            </div>
          </LanguageContentRowBaseWrapper>
        </LanguageContentBaseWrapper>
      </Canvas>
    </LanguageBaseWrapper>
  );
};

export default LanguageSetting;
